import en from "./en-GB.json";
import no from "./no-NO.json";
import da from "./da-DK.json";
import sv from "./sv-SE.json";

import { createI18n } from "vue-i18n";
import { localStorageGetItem } from "@/localStorage/localStorage.ts";
const selectedLocale = localStorageGetItem("locale") || "en";
export const messages = {
  en,
  no,
  da,
  sv
};

export const i18n = createI18n({
  globalInjection: true,
  fallbackLocale: "en",
  legacy: false,
  locale: selectedLocale,
  messages: messages
});

export const languages = {
  en: "English",
  no: "Norwegian",
  da: "Danish",
  sv: "Swedish"
};

export const flags = {
  en: "/icons/locales/en.svg",
  no: "/icons/locales/no.svg",
  sv: "/icons/locales/sv.svg",
  da: "/icons/locales/da.svg"
};

export const t = i18n.global.t;
export const locale = i18n.global.locale.value as string;
